import {EventEmitter, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchFilterService {

  /**
   * Filterservice. Es muss für jeden FilterType ein neuer EventEmitter & Filter deklariert werden
   */
  onVorhersageSearchFilterUpdated: EventEmitter<string> = new EventEmitter<string>();
  onMesswerteSearchFilterUpdated: EventEmitter<string> = new EventEmitter<string>();
  onUvIndexSearchFilterUpdated: EventEmitter<string> = new EventEmitter<string>();


  constructor() {
  }

  public filter(filterValue, url?) {
    // console.log(url);
    switch (url) {
      case '/vorhersagen/computer-mos/uebersicht':
        this.filter24hVorhersagenBySearchValue(filterValue);
        break;
      case '/messwerte':
        this.filterMesswerteBySearchValue(filterValue);
        break;
      case '/vorhersagen/meteorologe/gesundheit/uv-index':
        this.filterUvIndexVorhersagenBySearchValue(filterValue);
        break;
    }

  }

  private filter24hVorhersagenBySearchValue(filterValue: string) {
    this.onVorhersageSearchFilterUpdated.emit(filterValue.trim().toLowerCase());
  }

  private filterMesswerteBySearchValue(filterValue) {
    this.onMesswerteSearchFilterUpdated.emit(filterValue.trim().toLowerCase());
  }

  private filterUvIndexVorhersagenBySearchValue(filterValue) {
    this.onUvIndexSearchFilterUpdated.emit(filterValue.trim().toLowerCase());
  }
}
